import { useEffect } from 'react'
import { createPortal } from 'react-dom'

export function BotRightsResolvedModal({
  onDone,
  message = 'Все в порядке: права получены. Можно публиковать.',
}: {
  onDone: () => void
  message?: string
}) {
  useEffect(() => {
    const timer = window.setTimeout(onDone, 1400)
    return () => window.clearTimeout(timer)
  }, [onDone])

  return createPortal(
    <div className="brr-veil">
      <div className="brr-modal" role="status" aria-live="polite">
        <div className="brr-icon" aria-hidden>
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <path d="M20 6L9 17l-5-5" />
          </svg>
        </div>
        <div className="brr-title">Права обновились</div>
        <div className="brr-sub">{message}</div>
      </div>

      <style>{`
        .brr-veil {
          position: fixed;
          inset: 0;
          z-index: 1250;
          background: rgba(15, 18, 24, 0.22);
          backdrop-filter: blur(4px);
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 20px;
          box-sizing: border-box;
        }
        .brr-modal {
          width: min(420px, 100%);
          padding: 24px 22px;
          border-radius: 20px;
          background: white;
          text-align: center;
          box-shadow: 0 24px 60px -18px rgba(15, 18, 24, 0.34);
        }
        .brr-icon {
          width: 56px;
          height: 56px;
          margin: 0 auto 14px;
          border-radius: 50%;
          background: rgba(0, 168, 96, 0.12);
          color: var(--tg-up, #00a860);
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .brr-icon svg {
          width: 28px;
          height: 28px;
        }
        .brr-title {
          font-size: 20px;
          font-weight: 800;
          color: var(--tg-ink, #111);
          margin-bottom: 8px;
        }
        .brr-sub {
          font-size: 14px;
          line-height: 1.5;
          color: var(--tg-ink-2, #333);
        }
        @media (max-width: 640px) {
          .brr-modal {
            padding: 20px 16px;
            border-radius: 18px;
          }
          .brr-title {
            font-size: 18px;
          }
          .brr-sub {
            font-size: 13.5px;
          }
        }
      `}</style>
    </div>,
    document.body,
  )
}
